import type React from "react"
import { useTranslation } from "react-i18next"

import DataAlertBase from "../dataAlertBase/dataAlertBase"

const DataAlertPreview: React.FC = () => {
  const { t } = useTranslation()

  return (
    <DataAlertBase
      body={t("dataAlertPreview.description", { ns: "reports" })}
      title={t("dataAlertPreview.title", { ns: "reports" })}
    />
  )
}

export default DataAlertPreview
